export const getAsterisks = (errorColor) => ` <strong style="color:${errorColor}" aria-hidden="true">*</strong>`;
/**
 * Returns the innerHtml adding the required asterisks if required
 */
export const getInnerHtmlAndInsertAsteriskIfRequired = (label, labelMarkup, required, errorColor) => {
    const innerHtml = labelMarkup || label || '';

    // Not required
    if (!required) return innerHtml;

    const asterisks = getAsterisks(errorColor);

    // No markup
    if (!labelMarkup) return `${innerHtml}${asterisks}`;

    // Requied and markup
    const position = innerHtml.lastIndexOf('</');
    const innerHTMLWithAsterisks = [innerHtml.slice(0, position), asterisks, innerHtml.slice(position)].join('');

    return innerHTMLWithAsterisks;
};
